import React from 'react';
import useEpisodePlayersContext from '../../hooks/useEpisodePlayersContext';

const LoadMoreButton = ({ viewMore }) => {
    const { setScrollDisabled } = useEpisodePlayersContext();
    const blockScroll = () => {
        setScrollDisabled(true);
    };

    return (
        <button
            className="player-app__btn-view-more"
            onClick={() => {
                blockScroll();
                viewMore();
            }}
        >
            View more
        </button>
    );
};

export default LoadMoreButton;
